<template>
  <!-- 遗嘱管理 -->
  <basic-container>
    <avue-crud
      ref="crud"
      :option="tableOption"
      :table-loading="loading"
      :data="listData"
      :page.sync="tablePage"
      :search.sync="searchForm"
      v-model="tableForm"
      :permission="permissionList"
      :before-open="beforeOpenForm"
      :before-close="beforeCloseForm"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @refresh-change="loadData"
      @on-load="loadData"
    >
      <template slot="elderlyIdSearch">
        <el-select style="width: 100%" placeholder="老人" v-model="searchForm.elderlyId" filterable clearable>
          <el-option
            v-for="(item, index) in elderlyList"
            :key="index"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </template>
      <template slot="entrustTimeForm">
        <el-date-picker
          :readonly="formType == 'view'"
          v-model="tableForm.entrustTime"
          type="datetime"
          placeholder="选择时间"
          format="yyyy-MM-dd hh:mm:ss"
          value-format="yyyy-MM-dd hh:mm:ss"
        ></el-date-picker>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import { mapGetters } from 'vuex';
import { getNursinghomeList } from '../api/public.js';
import {
  getElderlyListApi,
  getPageListApi,
  addApi,
  updateApi,
  removeApi,
} from '../api/mandateManage';

export default {
  data() {
    return {
      oldNursinghomeId: '', // 旧养老院id，重置搜索条件和新增时需要使用
      nursinghomeList: [], // 养老院列表
      elderlyList: [], // 老人列表
      // 搜索表单
      searchForm: {
        nursinghomeId: '',
      },
      tableForm: {}, // crud表单
      formType: '', // curd表单类型
      needCloseConfirm: false, // 关闭弹框时是否需要确认弹框，该值是根据场景动态调整的
      listData: [], // 列表数据
      isFirstLoadData: true, // 是否为第一次获取数据
      loading: false,
      // 数据的分页信息
      tablePage: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      // 数据的表格展示配置项
      tableOption: {
        height: 'auto',
        calcHeight: 'auto',
        border: true,
        index: true,
        viewBtn: true,
        dialogClickModal: false,
        searchMenuSpan: 6,
        searchLabelWidth: 100,
        labelWidth: 100,
        column: [
          {
            label: '服务网点',
            prop: 'nursinghomeId',
            dicData: [],
            props: {
              label: 'name',
              value: 'id',
            },
            type: 'select',
            hide: true,
            showColumn: false,
            disabled: true,
            search: true,
            searchClearable: false,
            rules: [
              {
                required: true,
                message: '请选择服务网点',
                trigger: 'change',
              },
            ],
          },
          {
            label: '老人',
            prop: 'elderlyId',
            dicData: [],
            props: {
              label: 'name',
              value: 'id',
            },
            dataType: 'string',
            type: 'select',
            filterable: true,
            search: true,
            searchslot: true,
            rules: [
              {
                required: true,
                message: '请选择老人',
                trigger: 'change',
              },
            ],
          },
          {
            label: '嘱托事件',
            prop: 'entrustEvent',
            search: true,
            maxlength: '30',
            showWordLimit: true,
            rules: [
              {
                required: true,
                message: '请输入嘱托事件',
                trigger: 'change',
              },
            ],
          },
          {
            label: '嘱托时间',
            prop: 'entrustTime',
            formslot: true,
            rules: [
              {
                required: true,
                message: '请选择嘱托时间',
                trigger: 'change',
              },
            ],
          },
          {
            label: '描述',
            prop: 'description',
            type: 'textarea',
            span: 24,
            maxlength: '200',
            minRows: 3,
            maxRows: 5,
            showWordLimit: true,
          },
        ],
      },
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        viewBtn: this.vaildData(this.permission.mandate_add, false),
        addBtn: this.vaildData(this.permission.mandate_add, false),
        editBtn: this.vaildData(this.permission.mandate_edit, false),
        delBtn: this.vaildData(this.permission.mandate_del, false),
      };
    },
  },
  watch: {
    'searchForm.nursinghomeId'(val) {
      if (val) {
        // 更新老人列表
        getElderlyListApi({
          id: this.searchForm.nursinghomeId,
        })
          .then(({ data }) => {
            this.elderlyList = data;
            // if (this.elderlyList.length > 0) {
              // 要先获取到老人列表再去获取表格数据，否则表格数据里的老人信息渲染不出来
              // if (this.isFirstLoadData) {
                // this.isFirstLoadData = false;
                // 老人的更新一定要注意时机，否则表格里的老人会显示成id，并非name
                // this.findObject(this.tableOption.column, 'elderlyId').dicData = this.elderlyList;
                this.$refs.crud.updateDic('elderlyId', this.elderlyList)
                this.oldNursinghomeId = this.searchForm.nursinghomeId;
                this.loadData();
              // }
            // } else {
            //   this.isFirstLoadData = false;
            // }
          })
          .catch(() => {
            // this.isFirstLoadData = false;
          });
      }
    },
  },
  created() {
    getNursinghomeList().then(({ data }) => {
      this.nursinghomeList = data || [];
      if (this.nursinghomeList.length > 0) {
        this.findObject(this.tableOption.column, 'nursinghomeId').dicData = this.nursinghomeList;
        this.searchForm.nursinghomeId = this.nursinghomeList[0].id;
        this.oldNursinghomeId = this.searchForm.nursinghomeId;
        this.loadData();
      }
    });
  },
  mounted() {
    this.ajustView();
  },
  activated() {
    // 当从其它窗口切换回当前页面时，表格线会错乱，加上如下处理可解决此问题
    this.$nextTick(() => {
      this.$refs.crud.refreshTable();
    });
  },
  methods: {
    /* 调整视图区域 */
    ajustView() {
      const tableInitH = this.bodyHeight - 330; // 表格区域初始化高度
      const searchH = 57; // 搜索区域占的高度
      this.tableOption.height = tableInitH;

      this.$nextTick(() => {
        setTimeout(() => {
          let children = this.$refs.crud.$children[1].$children;
          children[children.length - 2].$el.addEventListener('click', () => {
            if (this.tableOption.height == tableInitH) {
              this.tableOption.height = tableInitH + searchH;
            } else {
              this.tableOption.height = tableInitH;
            }
            this.$refs.crud.getTableHeight();
          });
        });
      });

      // 当窗口尺寸发生变化时，表格线会错乱，加上如下处理可解决此问题
      setTimeout(() => {
        window.onresize = () => {
          this.$nextTick(() => {
            this.$refs.crud.refreshTable();
          });
        };
      });
    },
    loadData(page) {
      // if (this.isFirstLoadData) return;
      page = page || this.tablePage;
      this.loading = true;
      getPageListApi(
        Object.assign({ current: page.currentPage, size: page.pageSize }, this.searchForm)
      ).then(({ data }) => {
        this.tablePage.total = data.total;
        this.listData = data.records;
        this.loading = false;
      });
    },
    /* 重置搜索 */
    searchReset() {
      this.searchForm = {
        nursinghomeId: this.oldNursinghomeId,
      };
      this.tablePage.currentPage = 1;
      this.loadData();
    },
    /* 条件搜索 */
    searchChange(params, done) {
      // tips: 这里不要使用findObject的方式去改字典，这个方式改了字典后新增时的字典还是旧的
      // this.$refs.crud.updateDic('elderlyId', this.elderlyList); // 在搜索时才更新老人的数据，否则如果只是单纯的切换养老院这个搜索条件，又提前更新了老人数据，那表格里的老人就会显示成老人id了
      this.searchForm = params;
      this.tablePage.currentPage = 1;
      this.loadData();
      done();
    },
    beforeOpenForm(done, type) {
      this.needCloseConfirm = true;
      this.formType = type;
      if (type == 'add') {
        this.tableForm = {
          nursinghomeId: this.oldNursinghomeId,
        };
      } else {
        if (type == 'view') {
          this.needCloseConfirm = false;
        }
      }
      done();
    },
    beforeCloseForm(done, type) {
      if (!this.needCloseConfirm) {
        done();
      } else {
        this.$confirm('确定关闭页面?', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          done();
        });
      }
    },
    rowSave(row, done, loading) {
      addApi(row).then(
        () => {
          this.loadData();
          this.$message.success('操作成功!');
          this.needCloseConfirm = false;
          done();
        },
        () => {
          loading();
        }
      );
    },
    rowUpdate(row, index, done, loading) {
      updateApi(row).then(
        () => {
          this.loadData();
          this.$message.success('操作成功!');
          this.needCloseConfirm = false;
          done();
        },
        () => {
          loading();
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return removeApi({
            ids: row.id,
          });
        })
        .then(() => {
          this.loadData();
          this.$message.success('操作成功!');
        });
    },
  },
};
</script>

<style lang="scss" scoped>
/* 搜索按钮靠右对齐 */
::v-deep .avue-form__menu--center {
  text-align: right !important;
}

/* 表单的每一项宽度最大化 */
::v-deep .el-form-item {
  width: 100%;
}
</style>
